
export const PROPERTIES = {
    HEIGHT_PX: 'HeightPX',
    HEIGHT_AUTO: 'HeightAuto',
}